module.exports = __webpack_public_path__ + "img/es-pc-step-4.b67b98b3.png";